/**
 * Get a cookie
 * @param name - Name of the cookie to get
 * @returns The cookie's value
 */
export default function getCookie(name: string): string | null {
	const getCookieValues = (cookie: string): string => {
		const cookieArray = cookie.split('=')
		return cookieArray[1].trim()
	}

	const getCookieNames = (cookie: string): string => {
		const cookieArray = cookie.split('=')
		return cookieArray[0].trim()
	}

	const cookies = document.cookie.split(';')
	const cookieValue = cookies.map(getCookieValues)[cookies.map(getCookieNames).indexOf(name)]

	return cookieValue === undefined ? null : cookieValue
}
